module.exports = new __parcel__URL__("Sales Account Planning.1824dc16.svg").toString();